export const d = "https://mazey.cn";

export const ossApi = {
  upload: `${d}/server/upload`,
  query: `${d}/server/upload/query`,
  remove: `${d}/server/upload/remove`,
  ossConfsQuery: `${d}/server/upload/confs`,
  newOssConfsQuery: `${d}/server/upload/get-oss-confs`,
  ossConfsCreate: `${d}/server/upload/new-conf`,
  newOssConfsCreate: `${d}/server/upload/add-oss-conf`,
  login: `${d}/server/user/login`,
};

export const accessToken = "";
